import { ExtraServiceDetails, ProductWithQuantity } from "../../../createOrderTypes"

export const calculateClampedAmount = (service: ExtraServiceDetails, seatCount: number) => {
    const raw = service.pricePerSeat.amount * seatCount
    return Math.max(service.minimumPrice.amount, Math.min(raw, service.maximumPrice.amount))
}

export const isServiceAdded = (delivery: { orderLines: ProductWithQuantity[] }, serviceId: number) =>
    delivery.orderLines.some((p) => p.id === serviceId && p.isExtraService)
